import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useStores } from 'Hooks/useStore';
import { getAppRoutes } from 'Pages/App/App.constants';
import { SignInRequest } from 'Services/Api/Auth/Types';

/**
 * Handles grc-auth SSO return: /login?sso=<base64(user:pass)>
 * Same sign-in logic as before; shows a loading state instead of the form flash.
 */
export function useSsoReturnLogin() {
	const history = useHistory();
	const { authStore } = useStores();
	const ssoParams = useMemo(
		() => new URLSearchParams(window.location.search),
		[]
	);
	const hasSsoReturn = ssoParams.has('sso');
	const [ssoProcessing, setSsoProcessing] = useState(hasSsoReturn);

	useEffect(() => {
		if (!hasSsoReturn) {
			return;
		}

		let cancelled = false;

		(async () => {
			try {
				localStorage.clear();
				const rawcreds = atob(ssoParams.get('sso')!);
				const creds = rawcreds.split(':');
				const ssologin: SignInRequest = {
					login: creds[0],
					password: creds[1]
				};
				await authStore.signIn(ssologin);
				if (cancelled) {
					return;
				}
				history.push(getAppRoutes().HOME, { userLoggedIn: true });
			} catch {
				if (!cancelled) {
					setSsoProcessing(false);
				}
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [authStore, hasSsoReturn, history, ssoParams]);

	return { ssoProcessing, ssoParams };
}
